import React from 'react';
import { motion } from 'framer-motion';
import { User } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FixedWidgets from '../components/FixedWidgets';
import santosh from '../assets/santosh.jpeg';
import suma from '../assets/suma.jpeg';
import radha from '../assets/radha.jpeg';
import miraj from '../assets/miraj.jpeg';
import sweta from '../assets/sweta.jpeg';
import sheela from '../assets/sheela.jpeg';
import ramesh from '../assets/ramesh.jpeg';
import chand from '../assets/chandrashekar.jpeg';
import rashmi from '../assets/rashmi.jpeg';
import maldar from '../assets/maldar.jpeg';


const ConsultantsPage = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 }
  };

  const consultants = [
  {
    name: 'DR. Santosh Vastrad',
    speciality: 'Consultant Physician, Diabetes and Thyroid Specialist)',
    education: 'MBBS, MD (Int. Med), FDE (Endocrinology)',
    image: santosh,
    color: 'from-[#4A90A4] to-[#6FCF97]'
  },
  {
    name: 'Dr. Suma D. P.',
    speciality: 'Consultant Pathologist',
    education: 'MD (Path)',
    image: suma,
    color: 'from-[#4A90A4] to-[#6FCF97]'
  },
  {
    name: 'Dr. Chandrashekar V. Mudgal',
    speciality: 'Orthopaedic Surgeon',
    education: 'MBBS, MS (Ortho)',
    image: chand,
    color: 'from-[#6FCF97] to-[#4A90A4]'
  },
  {
    name: 'Dr. Radha M. Swamy',
    speciality: 'Obstetrician And Gynaecology',
    education: 'MD (OB & GYN)',
    image: radha,
    color: 'from-[#6FCF97] to-[#4A90A4]'
  },
  {
    name: 'Dr. Rashmi Kabadi',
    speciality: 'Obsterics And Gynaecology (Laproscopic Surgeon)',
    education: 'MBBS, MS (OBG  & GYN)',
    image: rashmi,
    color: 'from-[#6FCF97] to-[#4A90A4]'
  },
  {
    name: 'Dr. Ramesh Hosmani',
    speciality: 'General, ONCO & Laproscopic Surgeon',
    education: 'MS (Gen Surgeon), FMAS',
    image: ramesh,
    color: 'from-[#6FCF97] to-[#4A90A4]'
  },
  {
    name: 'Dr. S. A. Miraj',
    speciality: 'Senior Consultant & Children Specialist',
    education: 'MBBS, DCH',
    image: miraj,
    color: 'from-[#6FCF97] to-[#4A90A4]'
  },
  {
    name: 'Dr. Shadab Maldar',
    speciality: 'Consultant Pediatrician & Neonatologiest',
    education: 'MD, DNB, PGPN (Boston), IPPN',
    image: maldar,
    color: 'from-[#6FCF97] to-[#4A90A4]'
  },
  {
    name: 'Dr. Swetha Vernekar',
    speciality: 'Consultant Obstretrics And Gyanaecology',
    education: 'MBBS, MD, OBG',
    image: sweta,
    color: 'from-[#6FCF97] to-[#4A90A4]'
  },
  {
    name: 'Dr. Sheela Tanawade',
    speciality: 'Gyanaecology',
    education: 'MBBS, OBG, Gyanaecology, DGO',
    image: sheela,
    color: 'from-[#6FCF97] to-[#4A90A4]'
  },
];


  return (
    <div className="min-h-screen bg-white">
      <Header />
      <FixedWidgets />

      {/* Hero Section */}
      <section className="relative h-[50vh] flex items-center justify-center overflow-hidden mt-20">
        <motion.div
          initial={{ scale: 1.2 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.5 }}
          className="absolute inset-0 z-0"
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1e3a5f]/90 to-[#4A90A4]/80 z-10" />
          <img
            src="https://images.unsplash.com/photo-1728474372689-c3072b79806e"
            alt="Consultants"
            className="w-full h-full object-cover"
          />
        </motion.div>

        <div className="relative z-20 max-w-7xl mx-auto px-6 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-5xl md:text-6xl font-bold text-white mb-6"
          >
            Our <span className="text-[#6FCF97]">Expert Consultants</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-xl text-gray-200 max-w-3xl mx-auto"
          >
            Experienced medical professionals dedicated to your health
          </motion.p>
        </div>
      </section>

      {/* Consultants Grid */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {consultants.map((consultant, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.03 }}
                whileHover={{ y: -10, scale: 1.03 }}
                className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
              >
                <div className="h-64 relative overflow-hidden">
                {consultant.image ? (
                  <img
                    src={consultant.image}
                    alt={consultant.name}
                    className="w-full h-full object-cover object-top"

                  />
                ) : (
                  <div className={`w-full h-full bg-gradient-to-br ${consultant.color} flex items-center justify-center`}>
                    <motion.div
                      whileHover={{ rotate: 360, scale: 1.2 }}
                      transition={{ duration: 0.5 }}
                      className="w-20 h-20 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center"
                    >
                      <User className="text-white" size={36} />
                    </motion.div>
                  </div>
                )}

                <div className="absolute inset-0 opacity-10">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-white rounded-full transform translate-x-16 -translate-y-16" />
                  <div className="absolute bottom-0 left-0 w-24 h-24 bg-white rounded-full transform -translate-x-12 translate-y-12" />
                </div>
              </div>

                <div className="p-5">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{consultant.name}</h3>
                  <p className="text-sm text-gray-600 font-medium">{consultant.speciality}</p>
                  <p className="text-xs text-gray-500 mt-1">{consultant.education}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Appointment CTA */}
      <section className="py-20 bg-gradient-to-br from-[#1e3a5f] to-[#2d5a7b] text-white">
  <motion.div
    {...fadeInUp}
    className="max-w-4xl mx-auto px-6 text-center flex flex-col items-center"
  >
    <h2 className="text-4xl md:text-5xl font-bold mb-6">
      Book an Appointment
    </h2>

    <p className="text-gray-300 text-lg mb-8">
      Schedule a consultation with our expert doctors
    </p>

    {/* BUTTON 1 */}
    <motion.a
      href="tel:0836-2350681"
      whileHover={{ scale: 1.05, boxShadow: '0 10px 40px rgba(111, 207, 151, 0.3)' }}
      whileTap={{ scale: 0.95 }}
      className="w-fit px-6 py-3 bg-[#6FCF97] text-white rounded-full font-semibold text-base hover:bg-[#5ABD82] transition-all duration-300"
    >
      Call Now: 0836-2350681
    </motion.a>

    {/* BUTTON 2 */}
    <motion.a
      href="tel:+919380862119"
      whileHover={{ scale: 1.05, boxShadow: '0 10px 40px rgba(111, 207, 151, 0.3)' }}
      whileTap={{ scale: 0.95 }}
      className="w-fit mt-4 px-6 py-3 bg-[#6FCF97] text-white rounded-full font-semibold text-base hover:bg-[#5ABD82] transition-all duration-300"
    >
      Call Now: +91 9380862119
    </motion.a>

  </motion.div>
</section>



      <Footer />
    </div>
  );
};

export default ConsultantsPage;